import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { ProfessionalComponent } from './professional.component';
import { switchMap, take } from 'rxjs/operators';
import { Selectors } from 'features/profiles-state/+state/profiles-state.state';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { SmartModalService } from '@certemy/ui-components';

@Injectable()
export class CanDeactivateProfessionalService  {
  constructor(private store: Store<any>, private smartModalService: SmartModalService) {}

  canDeactivate(
    component: ProfessionalComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ) {
    return nextState.url.startsWith('/switch-profile') ? this.showConfirmationOnSwitch() : of(true);
  }

  private showConfirmationOnSwitch(): Observable<boolean> {
    return this.store.select(Selectors.isLoggedAsProfile).pipe(
      take(1),
      switchMap(isLoggedAs => {
        if (!isLoggedAs) {
          return of(true);
        } else {
          return this.smartModalService.openConfirm({
            title: 'Back to your account',
            body:
              "Once sent back to your account to access Professional's account you will have to use option to log in once again",
            successButtonText: 'Confirm',
          });
        }
      }),
    );
  }
}

export const canDeactivateProfessionalGuard: CanDeactivateFn<ProfessionalComponent> = (
    component: ProfessionalComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
) => {
  return inject(CanDeactivateProfessionalService).canDeactivate(component, currentRoute, currentState, nextState);
};
